import type { MapRegion } from "@/types"

export const leithaniaRegion: MapRegion = {
    id: "leithanien",
    name: "map.region.leithanien",
    mapImage: require("@/assets/imgs/map/leithania/map-leithania.png"),
    decoImage: require("@/assets/imgs/map/leithania/map-leithania-deco.png"),
    startNodeId: "lt-start",
    endNodeId: "lt-end",
    startDirection: "right",
    unlocked: false,
    order: 4,
    iconConfig: {
        question: {
            highlightIcon: require("@/assets/imgs/map/leithania/map-leithania-question-mark.png"),
            width: 180,
            height: 210,
        },
    },
    nodes: [
        {
            id: "lt-start",
            type: "start",
            level: 0,
            position: { x: 159, y: 650 },
            iconType: "question",
        },
        {
            id: "lt-evt3",
            type: "event",
            level: 1,
            position: { x: 301, y: 361 },
            eventId: "evt-lt-03",
            iconType: "building",
            iconOverride: {
                highlightIcon: require("@/assets/imgs/map/leithania/map-leithania-event-3.png"),
                width: 272,
                height: 350,
            },
        },
        {
            id: "lt-lessing",
            type: "event",
            level: 1,
            position: { x: 550, y: 576 },
            eventId: "dlg-lt-lessing",
            iconType: "building",
            iconOverride: {
                highlightIcon: require("@/assets/imgs/map/leithania/map-leithania-event-lessing.png"),
                width: 290,
                height: 227,
            },
        },
        {
            id: "lt-ebenholz",
            type: "event",
            level: 2,
            position: { x: 508, y: 170 },
            eventId: "dlg-lt-ebenholz",
            iconType: "building",
            iconOverride: {
                highlightIcon: require("@/assets/imgs/map/leithania/map-leithania-event-ebenholz.png"),
                width: 206,
                height: 227,
            },
        },
        {
            id: "lt-evt4",
            type: "event",
            level: 2,
            position: { x: 799, y: 374 },
            eventId: "evt-lt-04",
            iconType: "building",
            iconOverride: {
                highlightIcon: require("@/assets/imgs/map/leithania/map-leithania-event-4.png"),
                width: 332,
                height: 364,
            },
        },
        {
            id: "lt-evt5",
            type: "event",
            level: 2,
            position: { x: 1238, y: 402 },
            eventId: "evt-lt-05",
            iconType: "building",
            iconOverride: {
                highlightIcon: require("@/assets/imgs/map/leithania/map-leithania-event-5.png"),
                width: 204,
                height: 427,
            },
        },
        {
            id: "lt-evt1",
            type: "event",
            level: 3,
            position: { x: 847, y: 114 },
            eventId: "evt-lt-01",
            iconType: "question",
        },
        {
            id: "lt-evt2",
            type: "event",
            level: 3,
            position: { x: 1040, y: 279 },
            eventId: "evt-lt-02",
            iconType: "question",
        },
        {
            id: "lt-end",
            type: "end",
            level: 4,
            position: { x: 1344, y: 249 },
            iconType: "building",
            iconOverride: {
                highlightIcon: require("@/assets/imgs/map/leithania/map-leithania-target.png"),
                width: 150,
                height: 210,
            },
        },
    ],
    edges: [
        { from: "lt-start", to: "lt-evt3", waypoints: [] },
        { from: "lt-start", to: "lt-lessing", waypoints: [] },
        { from: "lt-evt3", to: "lt-ebenholz", waypoints: [] },
        { from: "lt-lessing", to: "lt-evt4", waypoints: [] },
        { from: "lt-lessing", to: "lt-evt5", waypoints: [{ x: 1000, y: 640 }] },
        { from: "lt-ebenholz", to: "lt-evt1", waypoints: [] },
        { from: "lt-ebenholz", to: "lt-evt4", waypoints: [] },
        { from: "lt-evt4", to: "lt-evt2", waypoints: [] },
        { from: "lt-evt5", to: "lt-end", waypoints: [] },
        { from: "lt-evt1", to: "lt-end", waypoints: [] },
        { from: "lt-evt2", to: "lt-end", waypoints: [] },
    ],
}
